import { useAuth } from "react-oidc-context";

/**
 * Convenience hook that returns the currently-valid access token, or undefined
 * when the user is anonymous or the renewal has failed. TanStack Query hooks
 * include this value in their query key so a refreshed token invalidates the
 * cache in-flight.
 */
export function useAccessToken(): string | undefined {
    const auth = useAuth();
    return auth.user?.access_token;
}
